import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import constants from "./constants";
// import { getS3Client } from "./Hooks/CheckAwsClient";
// import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
// const { getSignedUrl } = require("@aws-sdk/s3-request-presigner");

export async function apiCall(specs) {
  const payload = {
    timeout: 30000,
    method: specs.method,
    url: getAPIurl(specs),
    headers: {
      "Content-type": "application/json",
    },
  };

  if (
    (specs.body.language === "Java" ||
      specs.body.language === "C" ||
      specs.body.language === "CPP" ||
      specs.body.language === "Python" ||
      specs.body.language === "Javascript" ||
      specs.body.type === "testcode") &&
    (specs.body.type === "runcode" ||
      specs.body.type === "submitcode" ||
      specs.body.type === "testcode")
  ) {
    payload.data = specs.body;
  }

  return new Promise((resolve, reject) => {
    axios(payload)
      .then((result) => {
        if (result.data) {
          resolve(result.data);
        }

        if (result.data.message) {
          resolve(result.data.message);
        }
      })
      .catch((error) => {
        if (error) {
          reject(error);
        }

        reject(error);
      });
  });
}

const getAPIurl = (specs) => {
  if (specs.method === "post") {
    if (specs.language) {
      if (specs.api === "runcode" || specs.api === "testcode") {
        return process.env.REACT_APP_NODE_API + "node/learner/code/test";
      }

      if (specs.api === "submitcode") {
        return process.env.REACT_APP_NODE_API + "node/learner/code/submit";
      }

      // if (specs.language === "c" && specs.api === "submitcode") {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/c/submit"
      //   );
      // }

      // if (specs.language === "cpp" && specs.api === "submitcode") {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/cpp/submit"
      //   );
      // }

      // if (specs.language === "python" && specs.api === "submitcode") {
      //   return (
      //     process.env.REACT_APP_NODE_API +
      //     "node/learner/code/python/submit"
      //   );
      // }

      // if (specs.language === "java" && specs.api === "submitcode") {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/java/submit"
      //   );
      // }

      // if (
      //   specs.language === "java" &&
      //   (specs.api === "runcode" || specs.api === "testcode")
      // ) {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/java/test"
      //   );
      // }

      // if (
      //   specs.language === "c" &&
      //   (specs.api === "runcode" || specs.api === "testcode")
      // ) {
      //   return process.env.REACT_APP_NODE_API + "node/learner/code/c/test";
      // }

      // if (
      //   specs.language === "cpp" &&
      //   (specs.api === "runcode" || specs.api === "testcode")
      // ) {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/cpp/test"
      //   );
      // }

      // if (
      //   specs.language === "python" &&
      //   (specs.api === "runcode" || specs.api === "testcode")
      // ) {
      //   return (
      //     process.env.REACT_APP_NODE_API + "node/learner/code/python/test"
      //   );
      // }
    }
  }
};

export function getMinutesGap(givenTime) {
  const currentTime = moment();
  const expTime = moment(givenTime, "YYYY-MM-DD HH:mm:ss");
  const differenceInMinutes = expTime.diff(currentTime, "minutes");
  return differenceInMinutes;
}

export function getDataFromStorage(key) {
  //decoding the jwt access token comming from server

  if (window.localStorage.getItem("tokenKey")) {
    let result = jwt_decode(window.localStorage.getItem("tokenKey"));

    if (result.hasOwnProperty(key)) {
      // Guna - 8280, 20646

      // if (key === "learnerid") {
      //   return 22531;
      // }

      return result[key]?.toString() || null;
    }
  }

  // localStorage.setItem("img", result.picture);
  // localStorage.setItem("name", result.name);
  // // localStorage.setItem("batchid", result.batchid);
  // localStorage.setItem("learnerid", result.learnerid);
  // localStorage.setItem("role", result.role);
  // // setUserAuthInfo(result);
  // // setUserRole(result.role);
  // localStorage.setItem("lastlogin",result.lastlogin)
}

//export default apiCall;

export const isEnableProfileDetailsEdit = () => {
  return (
    getDataFromStorage("role") === constants.Roles.admin ||
    getDataFromStorage("role") === constants.Roles.trainer ||
    getDataFromStorage("role") === constants.Roles.learner ||
    getDataFromStorage("role") === constants.Roles.super_admin
  );
};

export const isGradiousAdmin = () => {
  const role = getDataFromStorage("role");
  const companyId = parseInt(getDataFromStorage("companyId"));
  return (
    (role === constants.Roles.super_admin || role === constants.Roles.admin) &&
    companyId === constants.GRADIOUS_ACCOUNT_ID
  );
};

export const isGradiousCompany = () => {
  const companyId = parseInt(getDataFromStorage("companyId"));
  return companyId === constants.GRADIOUS_ACCOUNT_ID;
};

// export const getPreSignedUrl = (filePath, from) => {
//   return new Promise(async (resolve, reject) => {
//     // const client = new S3Client({
//     //   region: process.env.REACT_APP_REGION,
//     //   credentials: {
//     //     accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
//     //     secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
//     //   },
//     // });
//     const client = await getS3Client();

//     const getObjectParams = {
//       Key: filePath,
//       Bucket:
//         from === "dp"
//           ? process.env.REACT_APP_DP_S3_BUCKET_NAME
//           : process.env.REACT_APP_S3_BUCKET_NAME,
//     };

//     const command = new GetObjectCommand(getObjectParams);

//     getSignedUrl(client, command, {
//       expiresIn:
//         from === "resume"
//           ? 3600
//           : getDataFromStorage("role") === constants.Roles.super_admin ||
//             getDataFromStorage("role") === constants.Roles.admin
//           ? 3600
//           : 60,
//     })
//       .then((url) => {
//         resolve(url);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export function generateBoilerPlateJSCode(
  functionName,
  argTypes,
  args,
  columns,
  returnType,
  isNoTestCases,
) {
  if (argTypes.includes("file")) {
    const parseArg = (type, index) => {
      const arg = args[index];
      if (type === "int")
        return `const ${arg} = parseInt(process.argv[${index + 2}]);`;
      if (type === "float")
        return `const ${arg} = parseFloat(process.argv[${index + 2}]);`;
      if (type === "Char")
        return `const ${arg} = process.argv[${index + 2}][0];`;
      if (type === "boolean")
        return `const ${arg} = Boolean(parseInt(process.argv[${index + 2}]));`;
      return `const ${arg} = process.argv[${index + 2}];`; // string, file
    };

    const params = args.join(", ");

    let boilerplate = `const fs = require('fs');\n\n`;

    boilerplate += `function ${functionName}(${params}) { // Don't change the number of parameters\n`;
    boilerplate += `    // Please Write your code here\n`;
    // if (returnType.value !== "void") {
    //   boilerplate += `    return null; // Replace with actual return\n`;
    // }
    boilerplate += `}\n\n`;

    // File Reader Helper
    if (
      (returnType.label === "New File" || returnType.label === "Same File") &&
      returnType.value === "void"
    ) {
      boilerplate += `function readFile(filename) {\n`;
      boilerplate += `    try {\n`;
      boilerplate += `        const data = fs.readFileSync(filename, 'utf8');\n`;
      boilerplate += `        console.log(data);\n`;
      boilerplate += `    } catch (err) {\n`;
      boilerplate += `        console.error('Error: Cannot open file', filename);\n`;
      boilerplate += `    }\n`;
      boilerplate += `}\n\n`;
    }

    // Main
    boilerplate += `const main = () => {\n`;
    argTypes.forEach((type, i) => {
      boilerplate += `    ${parseArg(type, i)}\n`;
    });

    const callExpr = `${functionName}(${args.join(", ")})`;
    const value = returnType.label === "New File" ? argTypes.length + 1 : 2;

    if (returnType.value === "void") {
      boilerplate += `    ${callExpr};\n`;
      if (returnType.label === "New File" || returnType.label === "Same File") {
        boilerplate += `    readFile(process.argv[${value}]);\n`;
      }
    } else {
      boilerplate += `    const result = ${callExpr};\n`;
      boilerplate += `    console.log(result);\n`;
    }

    boilerplate += `};\n\nmain();\n`;

    return boilerplate;
  } else if (!isNoTestCases) {
    const buildInputArgs = (item, index) => {
      const actIndex = index + 2;
      let appendStr;

      if (item === "int") appendStr = `parseInt(process.argv[${actIndex}])`;
      else if (item === "float" || item === "double")
        appendStr = `parseFloat(process.argv[${actIndex}])`;
      else if (item === "string") appendStr = `process.argv[${actIndex}] ?? ""`;
      else if (item === "boolean")
        appendStr = `process.argv[${actIndex}] === "true"`;
      else if (item === "char")
        appendStr = `process.argv[${actIndex}]?.length > 0 ? process.argv[${actIndex}][0] : '\\0'`;
      else if (item === "array-1int")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(x => parseInt(x))`;
      else if (item === "array-2int")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(row => row.map(x => parseInt(x)))`;
      else if (item === "array-1float")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(x => parseFloat(parseFloat(x).toFixed(2)))`;
      else if (item === "array-2float")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(row => row.map(x => parseFloat(parseFloat(x).toFixed(2))))`;
      else if (item === "array-1char")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(x => x.charAt(0))`;
      else if (item === "array-2char")
        appendStr = `JSON.parse(process.argv[${actIndex}]).map(row => row.map(x => x.charAt(0)))`;
      else if (item === "array-1boolean")
        appendStr = `JSON.parse(process.argv[${actIndex}])`;
      else if (item === "array-2boolean")
        appendStr = `JSON.parse(process.argv[${actIndex}])`;
      else if (item === "array-1string")
        appendStr = `JSON.parse(process.argv[${actIndex}])`;
      else if (item === "array-2string")
        appendStr = `JSON.parse(process.argv[${actIndex}])`;
      else if (item === "treenode")
        appendStr = `buildTree(JSON.parse(process.argv[${actIndex}]))`;
      else if (item === "listnode")
        appendStr = `buildList(JSON.parse(process.argv[${actIndex}]))`;
      else appendStr = `process.argv[${actIndex}]`;

      return appendStr;
    };

    // Build a NEW array — do not mutate argTypes, it may be reused by other language generators
    const inputArgs = argTypes.map(buildInputArgs);
    const functionArgs = inputArgs.join(", ");

    let printCode = "";
    const needTree =
      argTypes.includes("treenode") || returnType?.value === "treenode";
    const needList =
      argTypes.includes("listnode") || returnType?.value === "listnode";

    // Shown to the user in the solution template comment — constructor only
    let nodeDefForUser = "";
    // Used only in the actual runtime harness — constructor + builder + serializer
    let nodeLogicRuntime = "";

    if (
      returnType?.value === "array-1int" ||
      returnType?.value === "array-1char"
    ) {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.join(", ") + "]");
`;
    } else if (returnType?.value === "array-1string") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.map(s => JSON.stringify(s)).join(", ") + "]");
`;
    } else if (returnType?.value === "array-1boolean") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.join(", ") + "]");
`;
    } else if (
      returnType?.value === "array-2int" ||
      returnType?.value === "array-2char" ||
      returnType?.value === "array-2boolean"
    ) {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.map(row => "[" + row.join(", ") + "]").join(", ") + "]");
`;
    } else if (returnType?.value === "array-2string") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.map(row => "[" + row.map(s => JSON.stringify(s)).join(", ") + "]").join(", ") + "]");
`;
    } else if (returnType?.value === "array-1float") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.map(x => x.toFixed(2)).join(", ") + "]");
`;
    } else if (returnType?.value === "array-2float") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write("[" + output.map(row => "[" + row.map(x => x.toFixed(2)).join(", ") + "]").join(", ") + "]");
`;
    } else if (returnType?.value === "treenode") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write(JSON.stringify(serializeTree(output)));`;
    } else if (returnType?.value === "listnode") {
      printCode = `const output = ${functionName}(${functionArgs});
process.stdout.write(JSON.stringify(serializeList(output)));`;
    } else {
      // Covers int, float, double, boolean, string, char
      printCode = `process.stdout.write(String(${functionName}(${functionArgs})));`;
    }

    // getNodeLogic
    if (needTree) {
      const treeConstructor = `function TreeNode(val, left, right) {
  this.val = (val === undefined ? 0 : val)
  this.left = (left === undefined ? null : left)
  this.right = (right === undefined ? null : right)
}
`;
      nodeDefForUser += `\n${treeConstructor}`;

      nodeLogicRuntime += `
${treeConstructor}
// Builds a linked TreeNode structure from LeetCode's level-order array format
function buildTree(arr) {
  if (!arr || arr.length === 0 || arr[0] === null) return null;
  const root = new TreeNode(arr[0]);
  const queue = [root];
  let i = 1;
  while (i < arr.length) {
    const node = queue.shift();
    if (i < arr.length) {
      const leftVal = arr[i++];
      if (leftVal !== null && leftVal !== undefined) {
        node.left = new TreeNode(leftVal);
        queue.push(node.left);
      }
    }
    if (i < arr.length) {
      const rightVal = arr[i++];
      if (rightVal !== null && rightVal !== undefined) {
        node.right = new TreeNode(rightVal);
        queue.push(node.right);
      }
    }
  }
  return root;
}

// Serializes a linked TreeNode structure back into LeetCode's level-order array format
function serializeTree(root) {
  if (!root) return [];
  const result = [];
  const queue = [root];
  while (queue.length) {
    const node = queue.shift();
    if (node === null) {
      result.push(null);
    } else {
      result.push(node.val);
      queue.push(node.left ?? null);
      queue.push(node.right ?? null);
    }
  }
  while (result.length && result[result.length - 1] === null) result.pop();
  return result;
}
`;
    }

    if (needList) {
      const listConstructor = `function ListNode(val, next) {
  this.val = (val === undefined ? 0 : val)
  this.next = (next === undefined ? null : next)
}
`;
      nodeDefForUser += `\n${listConstructor}`;

      nodeLogicRuntime += `
${listConstructor}
// Builds a linked ListNode structure from a flat array
function buildList(arr) {
  if (!arr || arr.length === 0) return null;
  const head = new ListNode(arr[0]);
  let curr = head;
  for (let i = 1; i < arr.length; i++) {
    curr.next = new ListNode(arr[i]);
    curr = curr.next;
  }
  return head;
}

// Serializes a linked ListNode structure back into a flat array
function serializeList(head) {
  const result = [];
  let curr = head;
  while (curr) {
    result.push(curr.val);
    curr = curr.next;
  }
  return result;
}
`;
    }

    // Solution template only shows the constructor shape, not builders/serializers
    let solutionTemplate = `/* Definition for node
${nodeDefForUser}
*/
function ${functionName} (${args.toString()}) {    // Don't change the number of parameters
    //Please write your return statement here
}
`;

    // Runtime harness gets the full logic (constructor + buildTree/buildList + serializers)
    const code = `
${nodeLogicRuntime}
//Please don't modify the below code
$solution
(function () {
${printCode}
})();`;

    return { boilerplate: code, solutionTemplate };
  } else {
    return {
      boilerplate: `// Start to write code from here`,
      solutionTemplate: `// Start to write code from here`,
    };
  }
}

export function generateBoilerPlateJavaCode(
  methodName,
  argTypes,
  args,
  columns,
  returnType,
  isNoTestCases,
) {
  const getDefaultReturn = (type) => {
    switch (type) {
      case "void":
        return "";
      case "int":
      case "float":
        return "0";
      case "boolean":
        return "false";
      case "char":
        return "'\\0'";
      case "string":
        return '""';
      default:
        return type.startsWith("array-") ? "null" : "null";
    }
  };
  if (argTypes.includes("file")) {
    const typeMap = {
      int: "int",
      float: "double",
      Char: "char",
      String: "String",
      boolean: "boolean",
      void: "void",
      file: "String",
    };

    const parseArg = (type, index) => {
      const arg = args[index];
      if (type === "int")
        return `${typeMap[type]} ${arg} = Integer.parseInt(args[${index}]);`;
      if (type === "float")
        return `${typeMap[type]} ${arg} = Double.parseDouble(args[${index}]);`;
      if (type === "Char")
        return `${typeMap[type]} ${arg} = args[${index}].charAt(0);`;
      if (type === "boolean")
        return `${typeMap[type]} ${arg} = Integer.parseInt(args[${index}]) != 0;`;
      return `${typeMap[type]} ${arg} = args[${index}];`; // string, file
    };

    // Function definition
    const params = argTypes
      .map((type, i) => `${typeMap[type]} ${args[i]}`)
      .join(", ");

    let boilerplate = `import java.io.*;\n\n`;
    boilerplate += `public class TestClass {\n\n`;

    boilerplate += `    public static ${
      typeMap[returnType.value]
    } ${methodName}(${params}) { // Don't change the number of parameters\n`;
    boilerplate += `        // Please write your code here\n`;
    boilerplate += `    }\n\n`;

    // File reader helper
    if (
      (returnType.label === "New File" || returnType.label === "Same File") &&
      returnType.value === "void"
    ) {
      boilerplate += `    public static void readFile(String filename) {\n`;
      boilerplate += `        try {\n`;
      boilerplate += `            BufferedReader br = new BufferedReader(new FileReader(filename));\n`;
      boilerplate += `            String line;\n`;
      boilerplate += `            while ((line = br.readLine()) != null) {\n`;
      boilerplate += `                System.out.print(line);\n`;
      boilerplate += `            }\n`;
      boilerplate += `            br.close();\n`;
      boilerplate += `        } catch (IOException e) {\n`;
      boilerplate += `            System.out.print("Error: Cannot open file " + filename);\n`;
      boilerplate += `        }\n`;
      boilerplate += `    }\n\n`;
    }

    // Main function
    boilerplate += `    public static void main(String[] args) {\n`;

    argTypes.forEach((type, i) => {
      boilerplate += `        ${parseArg(type, i)}\n`;
    });

    const callExpr = `${methodName}(${args.join(", ")})`;
    const value = returnType.label === "New File" ? argTypes.length - 1 : 0;

    if (returnType.value === "void") {
      boilerplate += `        ${callExpr};\n`;
      if (returnType.label === "New File" || returnType.label === "Same File") {
        boilerplate += `        readFile(args[${value}]);\n`;
      }
    } else {
      boilerplate += `        ${
        typeMap[returnType.value]
      } result = ${callExpr};\n`;
      boilerplate += `        System.out.print(result);\n`;
    }

    boilerplate += `    }\n}`;
    return boilerplate;
  } else if (!isNoTestCases) {
    // 1. Core Lookup Matrix for Array Code generation to maintain DRY principles
    const typeMap = {
      int: { javaType: "int", parse: "Integer.parseInt($val)" },
      float: { javaType: "float", parse: "Float.parseFloat($val)" },
      double: { javaType: "double", parse: "Double.parseDouble($val)" },
      string: { javaType: "String" },
      char: { javaType: "char", parse: "$val.charAt(0)" },
      boolean: { javaType: "boolean", parse: "Boolean.parseBoolean($val)" },
      "array-1int": {
        javaType: "int[]",
        type: "int",
        parse: "Integer.parseInt($val)",
      },
      "array-1float": {
        javaType: "float[]",
        type: "float",
        parse: "Float.parseFloat($val)",
      },
      "array-1char": {
        javaType: "char[]",
        type: "char",
        parse: "$val.charAt(0)",
      },
      "array-1boolean": {
        javaType: "boolean[]",
        type: "boolean",
        parse: "Boolean.parseBoolean($val)",
      },
      "array-2int": {
        javaType: "int[][]",
        type: "int",
        parse: "Integer.parseInt($val)",
      },
      "array-2float": {
        javaType: "float[][]",
        type: "float",
        parse: "Float.parseFloat($val)",
      },
      "array-2char": {
        javaType: "char[][]",
        type: "char",
        parse: "$val.charAt(0)",
      },
      "array-2boolean": {
        javaType: "boolean[][]",
        type: "boolean",
        parse: "Boolean.parseBoolean($val)",
      },
      "array-1string": { javaType: "String[]", type: "String" },
      "array-2string": { javaType: "String[][]", type: "String" },
      treenode: { javaType: "TreeNode", parse: "buildTree($val)" },
      listnode: { javaType: "ListNode", parse: "buildList($val)" },
    };

    let arrayInputProcLogic = ``;
    const passedArgs = [];
    const methodArgs = [];
    const needTree =
      argTypes.includes("treenode") || returnType?.value === "treenode";
    const needList =
      argTypes.includes("listnode") || returnType?.value === "listnode";
    let nodeLogic = ``;

    // 2. Generate Input Processing Logic and Method Parameters
    argTypes.forEach((item, index) => {
      const varName = args[index];

      // Handle Primitives
      if (
        !item.includes("array") &&
        item !== "treenode" &&
        item !== "listnode"
      ) {
        methodArgs.push(`${item === "string" ? "String" : item} ${varName}`);

        if (item === "int") passedArgs.push(`Integer.parseInt(args[${index}])`);
        else if (item === "float")
          passedArgs.push(`Float.parseFloat(args[${index}])`);
        else if (item === "double")
          passedArgs.push(`Double.parseDouble(args[${index}])`);
        else if (item === "string")
          passedArgs.push(`(args.length > ${index}) ? args[${index}] : ""`);
        else if (item === "char")
          passedArgs.push(
            `(args.length > ${index} && args[${index}].length() > 0) ? args[${index}].charAt(0) : '\\0'`,
          );
        else if (item === "boolean")
          passedArgs.push(`Boolean.parseBoolean(args[${index}])`);
        return;
      }

      // Handle Arrays (1D & 2D)
      const mapping = typeMap[item];
      methodArgs.push(`${mapping.javaType} ${varName}`);
      passedArgs.push(varName);
      console.log(item.split("-")[1], item, typeMap[item].javaType);

      if (item.startsWith("array-1")) {
        if (item === "array-1string") {
          arrayInputProcLogic += `String ${varName}Str = args[${index}];\nString[] ${varName} = ${varName}Str.equals("[]") ? new String[0] : ${varName}Str.replaceAll("[\\\\[\\\\]\\"]", "").split("\\\\s*,\\\\s*");\n`;
        } else {
          arrayInputProcLogic += `String ${varName}Str = args[${index}];\nString[] ${varName}StrArr = ${varName}Str.equals("[]") ? new String[0] : ${varName}Str.replaceAll("[\\\\[\\\\]\\"\\\\s]", "").split(",");\n${
            typeMap[item].type
          }[] ${varName} = new ${
            typeMap[item].type
          }[${varName}StrArr.length];\nfor (int i = 0; i < ${varName}StrArr.length; i++) { ${varName}[i] = ${mapping.parse.replace(
            "$val",
            `${varName}StrArr[i]`,
          )}; }\n`;
        }
      } else if (item.startsWith("array-2")) {
        arrayInputProcLogic += `\nString ${varName}Str = args[${index}];\nString[] ${varName}RowStrArr = ${varName}Str.split("],");\nint m_${index} = ${varName}RowStrArr.length;\nString firstRow_${index} = ${varName}RowStrArr[0].replaceAll("[\\\\[\\\\]\\"\\\\s]", "");\nint n_${index} = firstRow_${index}.isEmpty() ? 0 : firstRow_${index}.split(",").length;\n`;

        if (item === "array-2string") {
          arrayInputProcLogic += `String[][] ${varName} = new String[m_${index}][n_${index}];\nfor (int i = 0; i < m_${index}; i++) {\n  String[] cols = ${varName}RowStrArr[i].equals("[]") ? new String[0] : ${varName}RowStrArr[i].replaceAll("[\\\\[\\\\]\\"\\\\s]", "").split(",");\n  for (int j = 0; j < n_${index}; j++) { ${varName}[i][j] = cols[j].trim(); }\n}\n`;
        } else {
          arrayInputProcLogic += `${typeMap[item].type}[][] ${varName} = new ${
            typeMap[item].type
          }[m_${index}][n_${index}];\nfor (int i = 0; i < m_${index}; i++) {\n  String[] cols = ${varName}RowStrArr[i].equals("[]") ? new String[0] : ${varName}RowStrArr[i].replaceAll("[\\\\[\\\\]\\"\\\\s]", "").split(",");\n  for (int j = 0; j < n_${index}; j++) { ${varName}[i][j] = ${mapping.parse.replace(
            "$val",
            "cols[j]",
          )}; }\n}\n`;
        }
      } else if (item === "treenode") {
        arrayInputProcLogic += `\nString ${varName}Str = args[${index}];\nTreeNode ${varName} = buildTree(${varName}Str);\n`;
      } else if (item === "listnode") {
        arrayInputProcLogic += `\nString ${varName}Str = args[${index}];\nListNode ${varName} = buildList(${varName}Str);\n`;
      }
    });

    // 3. Setup Output Formatting and Display Decorators
    let printLogicBeg = ``,
      printLogicEnd = ``,
      helperMethods = ``;
    const retType = returnType?.value;
    // const changeRetype =
    //   typeMap[retType]?.javaType || (retType === "string" ? "String" : retType);
    if (needTree) {
      helperMethods += `\n  public static TreeNode buildTree(String input) {\n  if (input == null) return null;\n  input = input.trim();\n  if (input.equals("[]")) return null;\n  input = input.substring(1, input.length() - 1).trim();\n  if (input.isEmpty()) return null;\n  String[] parts = input.split("\\\\s*,\\\\s*");\n  if (parts[0].equalsIgnoreCase("null")) return null;\n\n  TreeNode root = new TreeNode(Integer.parseInt(parts[0]));\n  Queue<TreeNode> queue = new LinkedList<>();\n  queue.add(root);\n\n  int index = 1;\n  while (!queue.isEmpty() && index < parts.length) {\n    TreeNode node = queue.poll();\n\n    if (!parts[index].equals("null")) {\n      node.left = new TreeNode(Integer.parseInt(parts[index]));\n      queue.add(node.left);\n    }\n    index++;\n\n    if (index < parts.length && !parts[index].equals("null")) {\n      node.right = new TreeNode(Integer.parseInt(parts[index]));\n      queue.add(node.right);\n    }\n    index++;\n  }\n\n  return root;\n}`;
      nodeLogic += `\n  class TreeNode {
        int val;
        TreeNode left;
        TreeNode right;
        TreeNode() {}
        TreeNode(int val) { this.val = val; }
        TreeNode(int val, TreeNode left, TreeNode right) {
            this.val = val;
            this.left = left;
            this.right = right;
        }
    }\n`;
    }

    if (needList) {
      helperMethods += `\n  public static ListNode buildList(String input) {\n  if (input == null || input.isEmpty()) return null;\n  input = input.trim().replaceAll("[\\\\[\\\\]]", "");\n  String[] parts = input.split("\\\\s*,\\\\s*");\n  if (parts.length == 0 || parts[0].equals("null")) return null;\n\n  ListNode head = new ListNode(Integer.parseInt(parts[0]));\n  ListNode current = head;\n\n  for (int i = 1; i < parts.length; i++) {\n    if (!parts[i].equals("null")) {\n      current.next = new ListNode(Integer.parseInt(parts[i]));\n      current = current.next;\n    }\n  }\n\n  return head;\n}`;
      nodeLogic += `\n   class ListNode {
        int val;
        ListNode next;
        ListNode() {};
        ListNode(int val) { this.val = val; }
        ListNode(int val, ListNode next) { this.val = val; this.next = next; }
    }\n`;
    }

    if (retType === "array-1float") {
      helperMethods += `\npublic static String formatFloatArray(float[] arr) {\n  if (arr == null) return "null";\n  StringBuilder sb = new StringBuilder("[");\n  for (int i = 0; i < arr.length; i++) { sb.append(String.format("%.2f", arr[i])); if (i != arr.length - 1) sb.append(", "); }\n  return sb.append("]").toString();\n}`;
      printLogicBeg = `formatFloatArray(`;
      printLogicEnd = `)`;
    } else if (retType === "array-2float") {
      helperMethods += `\npublic static String format2DFloatArray(float[][] arr) {\n  if (arr == null) return "null";\n  StringBuilder sb = new StringBuilder("[");\n  for (int i = 0; i < arr.length; i++) {\n    sb.append("[");\n    for (int j = 0; j < arr[i].length; j++) { sb.append(String.format("%.2f", arr[i][j])); if (j != arr[i].length - 1) sb.append(", "); }\n    sb.append("]"); if (i != arr.length - 1) sb.append(", ");\n  }\n  return sb.append("]").toString();\n}`;
      printLogicBeg = `format2DFloatArray(`;
      printLogicEnd = `)`;
    } else if (
      ["array-1int", "array-1char", "array-1boolean"].includes(retType)
    ) {
      printLogicBeg = `Arrays.toString(`;
      printLogicEnd = `)`;
    } else if (
      ["array-2int", "array-2char", "array-2boolean"].includes(retType)
    ) {
      printLogicBeg = `Arrays.deepToString(`;
      printLogicEnd = `)`;
    } else if (retType === "treenode") {
      printLogicBeg = `printTree(`;
      printLogicEnd = `)`;

      helperMethods += `\n  public static String printTree(TreeNode root) {\n  if (root == null) {\n  return "[]";\n  }\n  Queue<TreeNode> queue = new LinkedList<>();\n  List<String> result = new ArrayList<>();\n  queue.offer(root);\n  while (!queue.isEmpty()) {\n    TreeNode node = queue.poll();\n    if (node == null) {\n    result.add("null");\n } else {\n    result.add(String.valueOf(node.val));\n   queue.offer(node.left);\n   queue.offer(node.right);\n    }\n  }\n  // Remove trailing nulls\n  int i = result.size() - 1;\n  while (i >= 0 && result.get(i).equals("null")) {\n  result.remove(i);\n  i--;\n}\n  return "[" + String.join(",", result) + "]";\n}`;
    } else if (retType === "listnode") {
      printLogicBeg = `printList(`;
      printLogicEnd = `)`;
      helperMethods += `\n  public static String printList(ListNode head) {\n  if (head == null) {\n    return "null";\n  }\n  StringBuilder sb = new StringBuilder("[");\n  while (head != null) {\n    sb.append(head.val).append(", ");\n    head = head.next;\n  }\n  // Remove trailing comma and space\n  if (sb.length() > 1) sb.setLength(sb.length() - 2);\n  sb.append("]");\n  return sb.toString();\n}`;
    }
    // 4. Output String Code Blocks Injection
    let executionStatement = ``;
    if (retType === "array-1string") {
      executionStatement = `Solution s = new Solution();\nString[] output = s.${methodName}(${passedArgs.join(
        ", ",
      )});\n      System.out.print("[");\n      for (int i = 0; i < output.length; i++) { System.out.print("\\"" + output[i] + "\\""); if (i < output.length - 1) System.out.print(", "); }\n      System.out.print("]");`;
    } else if (retType === "array-2string") {
      executionStatement = `Solution s = new Solution();\nString[][] output = s.${methodName}(${passedArgs.join(
        ", ",
      )});\n      System.out.print("[");\n      for (int i = 0; i < output.length; i++) {\n          System.out.print("[");\n          for (int j = 0; j < output[i].length; j++) { System.out.print("\\"" + output[i][j] + "\\""); if (j < output[i].length - 1) System.out.print(", "); }\n          System.out.print("]"); if (i < output.length - 1) System.out.print(", ");\n      }\n      System.out.print("]");`;
    } else {
      executionStatement = `Solution s = new Solution();\nSystem.out.print(${printLogicBeg}s.${methodName}(${passedArgs.join(
        ", ",
      )})${printLogicEnd});`;
    }

    let solutionTemplate = `/*${nodeLogic}*/\nclass Solution {
    public ${typeMap[returnType.value].javaType} ${methodName}(${argTypes.map(
      (type, i) => `${typeMap[type].javaType} ${args[i]}`,
    )}) { // Don't change the number of parameters
        // Please write your return statement here
        return ${getDefaultReturn(returnType.value)};
    }
  }`;
    let importStatements = ``;
    if (
      retType?.includes("array") ||
      argTypes.some((t) => t.includes("array"))
    ) {
      importStatements = `import java.util.Arrays;\n`;
    }
    if (retType === "treenode" || argTypes.some((t) => t === "treenode")) {
      importStatements += `import java.util.Queue;\nimport java.util.LinkedList;\nimport java.util.ArrayList;\nimport java.util.List;`;
    }
    if (retType === "listnode" || argTypes.some((t) => t === "listnode")) {
      importStatements += `import java.util.List;\nimport java.util.ArrayList;\n`;
    }
    // 5. Generate Final Executable dString
    return {
      boilerplate: `${importStatements}${nodeLogic}\npublic class TestClass {
  public static void main(String[] args) {
      ${arrayInputProcLogic.trim().replace(/\n/g, "\n      ")}
      ${executionStatement}
  }${helperMethods}
}`,
      solutionTemplate,
    };
  } else {
    const code = `public class TestClass {
      public static void main (String[] args) {
        // Start to write code from here
      } 
}`;

    return { boilerplate: code, solutionTemplate: code };
  }
}

export function generateBoilerPlatePythonCode(
  functionName,
  argTypes,
  args,
  columns,
  returnType,
  isNoTestCases,
) {
  if (argTypes.includes("file")) {
    const inputConversion = argTypes.map((type, index) => {
      const arg = args[index];
      if (type === "int") return `${arg} = int(sys.argv[${index + 1}])`;
      if (type === "float") return `${arg} = float(sys.argv[${index + 1}])`;
      if (type === "Char") return `${arg} = sys.argv[${index + 1}][0]`;
      if (type === "boolean")
        return `${arg} = bool(int(sys.argv[${index + 1}]))`;
      return `${arg} = sys.argv[${index + 1}]`; // string, file
    });

    // Function definition
    const params = args.join(", ");
    let boilerplate = `import sys\n\n`;

    boilerplate += `def ${functionName}(${params}):  # Don't change the number of parameters\n    # Please write your code here\n\n`;
    //   if (returnType.value !== "void") {
    //     boilerplate += `    return None\n\n`;
    //   } else {
    //     boilerplate += `    pass\n\n`;
    //   }

    // File Reader Helper if return is File
    if (
      (returnType.label === "New File" || returnType.label === "Same File") &&
      returnType.value === "void"
    ) {
      boilerplate += `def read_file(filename):\n    try:\n        with open(filename, 'r') as file:\n            print(file.read())\n    except FileNotFoundError:\n        print(f"Error: Cannot open file {filename}")\n\n`;
    }

    // Main
    boilerplate += `if __name__ == "__main__":\n`;
    inputConversion.forEach((line) => {
      boilerplate += `    ${line}\n`;
    });

    const callExpr = `${functionName}(${args.join(", ")})`;
    const value = returnType.label === "New File" ? argTypes.length : 1;

    if (returnType.value === "void") {
      boilerplate += `    ${callExpr}\n`;
      if (returnType.label === "New File" || returnType.label === "Same File") {
        boilerplate += `    read_file(sys.argv[${value}])\n`;
      }
    } else {
      boilerplate += `    result = ${callExpr}\n`;
      boilerplate += `    print(result)\n`;
    }

    return boilerplate;
  } else if (!isNoTestCases) {
    const buildInputArgsPython = (item, index) => {
      const actIndex = index + 1; // sys.argv[0] is script name, so args start at 1
      let appendStr;

      if (item === "int") appendStr = `int(sys.argv[${actIndex}])`;
      else if (item === "float" || item === "double")
        appendStr = `float(sys.argv[${actIndex}])`;
      else if (item === "string")
        appendStr = `sys.argv[${actIndex}] if len(sys.argv) > ${actIndex} else ""`;
      else if (item === "boolean")
        appendStr = `sys.argv[${actIndex}] == "true"`;
      else if (item === "char")
        appendStr = `sys.argv[${actIndex}][0] if len(sys.argv[${actIndex}]) > 0 else '\\0'`;
      else if (item === "array-1int")
        appendStr = `[int(x) for x in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-2int")
        appendStr = `[[int(x) for x in row] for row in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-1float")
        appendStr = `[round(float(x), 2) for x in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-2float")
        appendStr = `[[round(float(x), 2) for x in row] for row in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-1char")
        appendStr = `[x[0] for x in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-2char")
        appendStr = `[[x[0] for x in row] for row in json.loads(sys.argv[${actIndex}])]`;
      else if (item === "array-1boolean")
        appendStr = `json.loads(sys.argv[${actIndex}])`;
      else if (item === "array-2boolean")
        appendStr = `json.loads(sys.argv[${actIndex}])`;
      else if (item === "array-1string")
        appendStr = `json.loads(sys.argv[${actIndex}])`;
      else if (item === "array-2string")
        appendStr = `json.loads(sys.argv[${actIndex}])`;
      else if (item === "treenode")
        appendStr = `build_tree(json.loads(sys.argv[${actIndex}]))`;
      else if (item === "listnode")
        appendStr = `build_list(json.loads(sys.argv[${actIndex}]))`;
      else appendStr = `sys.argv[${actIndex}]`;

      return appendStr;
    };

    // Build a NEW array — do not mutate argTypes
    const inputArgsPython = argTypes.map(buildInputArgsPython);
    const functionArgsPython = inputArgsPython.join(", ");

    let printCodePython = "";
    const needTree =
      argTypes.includes("treenode") || returnType?.value === "treenode";
    const needList =
      argTypes.includes("listnode") || returnType?.value === "listnode";

    // Shown to the user in the solution template — class definition only
    let nodeDefForUserPython = "";
    // Used only in the runtime harness — class + builder + serializer
    let nodeLogicRuntimePython = "";

    if (
      returnType?.value === "array-1int" ||
      returnType?.value === "array-1char" ||
      returnType?.value === "array-1boolean"
    ) {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join(str(x) for x in output) + "]", end="")
`;
    } else if (returnType?.value === "array-1string") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join(json.dumps(x) for x in output) + "]", end="")
`;
    } else if (
      returnType?.value === "array-2int" ||
      returnType?.value === "array-2char" ||
      returnType?.value === "array-2boolean"
    ) {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join("[" + ", ".join(str(x) for x in row) + "]" for row in output) + "]", end="")
`;
    } else if (returnType?.value === "array-2string") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join("[" + ", ".join(json.dumps(x) for x in row) + "]" for row in output) + "]", end="")
`;
    } else if (returnType?.value === "array-1float") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join(f"{x:.2f}" for x in output) + "]", end="")
`;
    } else if (returnType?.value === "array-2float") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print("[" + ", ".join("[" + ", ".join(f"{x:.2f}" for x in row) + "]" for row in output) + "]", end="")
`;
    } else if (returnType?.value === "treenode") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print(json.dumps(serialize_tree(output)), end="")`;
    } else if (returnType?.value === "listnode") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print(json.dumps(serialize_list(output)), end="")`;
    } else if (returnType?.value === "boolean") {
      printCodePython = `output = ${functionName}(${functionArgsPython})
print(str(output).lower(), end="")`;
    } else {
      // Covers int, float, double, string, char
      printCodePython = `print(${functionName}(${functionArgsPython}), end="")`;
    }

    if (needTree) {
      const treeClass = `class TreeNode:
    def __init__(self, val=0, left=None, right=None):
        self.val = val
        self.left = left
        self.right = right
`;
      nodeDefForUserPython += `\n${treeClass}`;

      nodeLogicRuntimePython += `
${treeClass}
# Builds a linked TreeNode structure from LeetCode's level-order array format
def build_tree(arr):
    if not arr or arr[0] is None:
        return None
    root = TreeNode(arr[0])
    queue = [root]
    i = 1
    while i < len(arr):
        node = queue.pop(0)
        if i < len(arr):
            left_val = arr[i]
            i += 1
            if left_val is not None:
                node.left = TreeNode(left_val)
                queue.append(node.left)
        if i < len(arr):
            right_val = arr[i]
            i += 1
            if right_val is not None:
                node.right = TreeNode(right_val)
                queue.append(node.right)
    return root

# Serializes a linked TreeNode structure back into LeetCode's level-order array format
def serialize_tree(root):
    if not root:
        return []
    result = []
    queue = [root]
    while queue:
        node = queue.pop(0)
        if node is None:
            result.append(None)
        else:
            result.append(node.val)
            queue.append(node.left)
            queue.append(node.right)
    while result and result[-1] is None:
        result.pop()
    return result
`;
    }

    if (needList) {
      const listClass = `class ListNode:
    def __init__(self, val=0, next=None):
        self.val = val
        self.next = next
`;
      nodeDefForUserPython += `\n${listClass}`;

      nodeLogicRuntimePython += `
${listClass}
# Builds a linked ListNode structure from a flat array
def build_list(arr):
    if not arr:
        return None
    head = ListNode(arr[0])
    curr = head
    for x in arr[1:]:
        curr.next = ListNode(x)
        curr = curr.next
    return head

# Serializes a linked ListNode structure back into a flat array
def serialize_list(head):
    result = []
    curr = head
    while curr:
        result.append(curr.val)
        curr = curr.next
    return result
`;
    }

    // Solution template only shows the class definitions, not builders/serializers
    const pyArgs = args.join(", ");
    let solutionTemplatePython = `# Definition for node
"""${nodeDefForUserPython}"""
def ${functionName}(${pyArgs}):    # Don't change the number of parameters
    # Please write your return statement here
    pass
`;

    // Runtime harness gets everything
    const codePython = `import sys
import json
${nodeLogicRuntimePython}
# Please don't modify the below code
$solution
if __name__ == "__main__":
${printCodePython
  .split("\n")
  .map((line) => (line ? "    " + line : line))
  .join("\n")}
`;

    return {
      boilerplate: codePython,
      solutionTemplate: solutionTemplatePython,
    };
  } else {
    return {
      boilerplate: `# Start to write code from here`,
      solutionTemplate: `# Start to write code from here`,
    };
  }
}

export function generateBoilerPlateCCode(
  methodName,
  argTypes,
  args,
  columns,
  returnType,
  isNoTestCases,
) {
  // console.log("methodName",methodName, "argTypes",argTypes, "args",args, "returnType",returnType, "isNoTestCases",isNoTestCases);
  if (argTypes.includes("file")) {
    const typeMap = {
      int: "int",
      float: "float",
      Char: "char",
      String: "char*",
      boolean: "bool",
      void: "void",
      file: "char*",
    };

    const formatMap = {
      int: "%d",
      float: "%f",
      Char: "%c",
      String: "%s",
      boolean: "%d", // use %d to print 0 or 1 for bool
      void: "",
      file: "%s",
    };

    // Generate argv to function argument conversion
    const inputValues = [];
    argTypes.forEach((item, index) => {
      const argIndex = index + 1;
      if (item === "int") inputValues.push(`atoi(argv[${argIndex}])`);
      else if (item === "float" || item === "double")
        inputValues.push(`atof(argv[${argIndex}])`);
      else if (item === "String" || item === "file")
        inputValues.push(`argv[${argIndex}]`);
      else if (item === "Char") inputValues.push(`argv[${argIndex}][0]`);
      else if (item === "boolean") inputValues.push(`atoi(argv[${argIndex}])`);
      else inputValues.push(`argv[${argIndex}]`);
    });

    let boilerplate = `#include <stdio.h>\n#include <stdlib.h>\n#include <string.h>\n\n`;

    // User function definition
    let userFunction = `${typeMap[returnType.value]} ${methodName}(`;
    const params = [];

    for (let i = 0; i < argTypes.length; i++) {
      const argType = argTypes[i];
      const arg = args[i];
      params.push(`${typeMap[argType] || argType} ${arg}`);
    }

    userFunction +=
      params.join(", ") +
      `) { // Don't change the number of parameters\n    // Please write your code here\n`;
    userFunction += `}\n\n`;

    boilerplate += userFunction;

    // File Reader Helper (only when label is "File" and return is void)
    if (
      (returnType.label === "New File" || returnType.label === "Same File") &&
      returnType.value === "void"
    ) {
      boilerplate += `
    void readFile(const char* filename) {
        FILE *file = fopen(filename, "r");
        if (file == NULL) {
            printf("Error: Cannot open file %s\\n", filename);
            return;
        }
        char ch;
        while ((ch = fgetc(file)) != EOF) {
            putchar(ch);
        }
        fclose(file);
    }\n`;
    }

    // Main function
    boilerplate += `int main(int argc, char* argv[]) {\n`;

    const callExpr = `${methodName}(${inputValues.join(", ")})`;
    const value = returnType.label === "New File" ? argTypes.length : 1;

    if (returnType.value === "void") {
      boilerplate += `    ${callExpr};\n`;
      if (returnType.label === "new File" || returnType.label === "Same File") {
        // print the destination file
        boilerplate += `    readFile(argv[${value}]);\n`;
      }
    } else {
      boilerplate += `    ${typeMap[returnType.value]} result = ${callExpr};\n`;
      boilerplate += `    printf("${formatMap[returnType.value]}", result);\n`;
      if (returnType.value === "string") {
        boilerplate += `    free(result);\n`;
      }
    }

    boilerplate += `    return 0;\n}\n`;

    return boilerplate;
  } else if (!isNoTestCases) {
    const typeMap = {
      int: { cType: "int", parse: "atoi($val)" },
      float: { cType: "float", parse: "strtof($val, NULL)" },
      double: { cType: "double", parse: "strtod($val, NULL)" },
      string: { cType: "char*", parse: "strdup($val)" },
      char: { cType: "char", parse: "$val[0]" },
      boolean: { cType: "bool", parse: '(strcmp($val, "true") == 0)' },

      "array-1int": { cType: "int*", type: "int", parseFn: "parseIntArray" },
      "array-1float": {
        cType: "float*",
        type: "float",
        parseFn: "parseFloatArray",
      },
      "array-1char": {
        cType: "char*",
        type: "char",
        parseFn: "parseCharArray",
      },
      "array-1boolean": {
        cType: "bool*",
        type: "boolean",
        parseFn: "parseBoolArray",
      },
      "array-1string": {
        cType: "char**",
        type: "string",
        parseFn: "parseStringArray",
      },

      "array-2int": { cType: "int**", type: "int", parseFn: "parseIntArray2D" },
      "array-2float": {
        cType: "float**",
        type: "float",
        parseFn: "parseFloatArray2D",
      },
      "array-2char": {
        cType: "char**",
        type: "char",
        parseFn: "parseCharArray2D",
      },
      "array-2boolean": {
        cType: "bool**",
        type: "boolean",
        parseFn: "parseBoolArray2D",
      },
      "array-2string": {
        cType: "char***",
        type: "string",
        parseFn: "parseStringArray2D",
      },

      treenode: { cType: "TreeNode*", parse: "buildTree($val)" },
      listnode: { cType: "ListNode*", parse: "buildList($val)" },
    };

    const HELPER_LIB = {
      stripOuterBrackets: {
        deps: [],
        code: `static char* stripOuterBrackets(const char* s) {
    int len = strlen(s), start = 0, end = len - 1;
    while (start < len && (s[start] == '[' || s[start] == ' ')) start++;
    while (end >= start && (s[end] == ']' || s[end] == ' ')) end--;
    int newLen = end - start + 1; if (newLen < 0) newLen = 0;
    char* r = (char*)malloc(newLen + 1);
    strncpy(r, s + start, newLen); r[newLen] = '\\0';
    return r;
}`,
      },
      stripQuotesC: {
        deps: [],
        code: `static char* stripQuotesC(const char* s) {
    int len = strlen(s); char* buf = (char*)malloc(len + 1); int j = 0;
    for (int i = 0; i < len; i++) if (s[i] != '"' && s[i] != ' ') buf[j++] = s[i];
    buf[j] = '\\0'; return buf;
}`,
      },
      splitTopLevel: {
        deps: [],
        code: `static char** splitTopLevel(const char* s, int* count) {
    int len = strlen(s), capacity = 8, n = 0;
    char** parts = (char**)malloc(capacity * sizeof(char*));
    if (len == 0) { *count = 0; return parts; }
    int start = 0, depth = 0;
    for (int i = 0; i < len; i++) {
        if (s[i] == '[') depth++;
        else if (s[i] == ']') depth--;
        else if (s[i] == ',' && depth == 0) {
            char* part = (char*)malloc(i - start + 1);
            strncpy(part, s + start, i - start); part[i - start] = '\\0';
            if (n >= capacity) { capacity *= 2; parts = (char**)realloc(parts, capacity * sizeof(char*)); }
            parts[n++] = part; start = i + 1;
        }
    }
    char* last = (char*)malloc(len - start + 1);
    strncpy(last, s + start, len - start); last[len - start] = '\\0';
    if (n >= capacity) { capacity *= 2; parts = (char**)realloc(parts, capacity * sizeof(char*)); }
    parts[n++] = last;
    *count = n; return parts;
}`,
      },
      freeTokens: {
        deps: [],
        code: `static void freeTokens(char** tokens, int n) { for (int i = 0; i < n; i++) free(tokens[i]); free(tokens); }`,
      },
      parseIntArray: {
        deps: ["stripOuterBrackets", "splitTopLevel", "freeTokens"],
        code: `int* parseIntArray(const char* s, int* size) {
    char* inner = stripOuterBrackets(s); int n; char** t = splitTopLevel(inner, &n);
    int* arr = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = atoi(t[i]);
    freeTokens(t, n); free(inner); *size = n; return arr;
}`,
      },
      parseFloatArray: {
        deps: ["stripOuterBrackets", "splitTopLevel", "freeTokens"],
        code: `float* parseFloatArray(const char* s, int* size) {
    char* inner = stripOuterBrackets(s); int n; char** t = splitTopLevel(inner, &n);
    float* arr = (float*)malloc((n > 0 ? n : 1) * sizeof(float));
    for (int i = 0; i < n; i++) arr[i] = strtof(t[i], NULL);
    freeTokens(t, n); free(inner); *size = n; return arr;
}`,
      },
      parseCharArray: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "stripQuotesC",
        ],
        code: `char* parseCharArray(const char* s, int* size) {
    char* inner = stripOuterBrackets(s); int n; char** t = splitTopLevel(inner, &n);
    char* arr = (char*)malloc((n > 0 ? n : 1) * sizeof(char));
    for (int i = 0; i < n; i++) { char* c = stripQuotesC(t[i]); arr[i] = c[0]; free(c); }
    freeTokens(t, n); free(inner); *size = n; return arr;
}`,
      },
      parseBoolArray: {
        deps: ["stripOuterBrackets", "splitTopLevel", "freeTokens"],
        code: `bool* parseBoolArray(const char* s, int* size) {
    char* inner = stripOuterBrackets(s); int n; char** t = splitTopLevel(inner, &n);
    bool* arr = (bool*)malloc((n > 0 ? n : 1) * sizeof(bool));
    for (int i = 0; i < n; i++) arr[i] = (strcmp(t[i], "true") == 0);
    freeTokens(t, n); free(inner); *size = n; return arr;
}`,
      },
      parseStringArray: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "stripQuotesC",
        ],
        code: `char** parseStringArray(const char* s, int* size) {
    char* inner = stripOuterBrackets(s); int n; char** t = splitTopLevel(inner, &n);
    char** arr = (char**)malloc((n > 0 ? n : 1) * sizeof(char*));
    for (int i = 0; i < n; i++) arr[i] = stripQuotesC(t[i]);
    freeTokens(t, n); free(inner); *size = n; return arr;
}`,
      },
      parseIntArray2D: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "parseIntArray",
        ],
        code: `int** parseIntArray2D(const char* s, int* rows, int** colSizes) {
    char* inner = stripOuterBrackets(s); int n; char** rowStrs = splitTopLevel(inner, &n);
    int** arr = (int**)malloc((n > 0 ? n : 1) * sizeof(int*));
    int* cols = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = parseIntArray(rowStrs[i], &cols[i]);
    freeTokens(rowStrs, n); free(inner); *rows = n; *colSizes = cols; return arr;
}`,
      },
      parseFloatArray2D: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "parseFloatArray",
        ],
        code: `float** parseFloatArray2D(const char* s, int* rows, int** colSizes) {
    char* inner = stripOuterBrackets(s); int n; char** rowStrs = splitTopLevel(inner, &n);
    float** arr = (float**)malloc((n > 0 ? n : 1) * sizeof(float*));
    int* cols = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = parseFloatArray(rowStrs[i], &cols[i]);
    freeTokens(rowStrs, n); free(inner); *rows = n; *colSizes = cols; return arr;
}`,
      },
      parseCharArray2D: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "parseCharArray",
        ],
        code: `char** parseCharArray2D(const char* s, int* rows, int** colSizes) {
    char* inner = stripOuterBrackets(s); int n; char** rowStrs = splitTopLevel(inner, &n);
    char** arr = (char**)malloc((n > 0 ? n : 1) * sizeof(char*));
    int* cols = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = parseCharArray(rowStrs[i], &cols[i]);
    freeTokens(rowStrs, n); free(inner); *rows = n; *colSizes = cols; return arr;
}`,
      },
      parseBoolArray2D: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "parseBoolArray",
        ],
        code: `bool** parseBoolArray2D(const char* s, int* rows, int** colSizes) {
    char* inner = stripOuterBrackets(s); int n; char** rowStrs = splitTopLevel(inner, &n);
    bool** arr = (bool**)malloc((n > 0 ? n : 1) * sizeof(bool*));
    int* cols = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = parseBoolArray(rowStrs[i], &cols[i]);
    freeTokens(rowStrs, n); free(inner); *rows = n; *colSizes = cols; return arr;
}`,
      },
      parseStringArray2D: {
        deps: [
          "stripOuterBrackets",
          "splitTopLevel",
          "freeTokens",
          "parseStringArray",
        ],
        code: `char*** parseStringArray2D(const char* s, int* rows, int** colSizes) {
    char* inner = stripOuterBrackets(s); int n; char** rowStrs = splitTopLevel(inner, &n);
    char*** arr = (char***)malloc((n > 0 ? n : 1) * sizeof(char**));
    int* cols = (int*)malloc((n > 0 ? n : 1) * sizeof(int));
    for (int i = 0; i < n; i++) arr[i] = parseStringArray(rowStrs[i], &cols[i]);
    freeTokens(rowStrs, n); free(inner); *rows = n; *colSizes = cols; return arr;
}`,
      },
    };

    // Resolve a set of requested helper names into the full dependency closure,
    // in a safe emission order (deps before dependents).
    function resolveHelpers(requested) {
      const included = new Set();
      const order = [];
      function visit(name) {
        if (included.has(name)) return;
        included.add(name);
        const entry = HELPER_LIB[name];
        if (!entry) return;
        entry.deps.forEach(visit);
        order.push(name);
      }
      requested.forEach(visit);
      return order.map((name) => HELPER_LIB[name].code).join("\n\n");
    }

    let arrayInputProcLogic = ``;
    const passedArgs = [];
    const methodArgs = [];
    const needTree =
      argTypes.includes("treenode") || returnType?.value === "treenode";
    const needList =
      argTypes.includes("listnode") || returnType?.value === "listnode";
    const usedHelpers = new Set();

    // ---- 1. Input processing + call-site args + method signature params ----
    argTypes.forEach((item, index) => {
      const varName = args[index];
      const actIndex = index + 1; // argv[0] is program name
      const mapping = typeMap[item];

      if (
        item === "int" ||
        item === "float" ||
        item === "double" ||
        item === "string" ||
        item === "boolean"
      ) {
        passedArgs.push(mapping.parse.replace("$val", `argv[${actIndex}]`));
        methodArgs.push(`${mapping.cType} ${varName}`);
        return;
      }

      if (item === "char") {
        passedArgs.push(mapping.parse.replace("$val", `argv[${actIndex}]`));
        methodArgs.push(`${mapping.cType} ${varName}`);
        return;
      }

      if (item === "treenode") {
        arrayInputProcLogic += `TreeNode* ${varName} = buildTree(argv[${actIndex}]);\n`;
        passedArgs.push(varName);
        methodArgs.push(`${mapping.cType} ${varName}`);
        usedHelpers.add("parseIntArray");
        return;
      }

      if (item === "listnode") {
        arrayInputProcLogic += `ListNode* ${varName} = buildList(argv[${actIndex}]);\n`;
        passedArgs.push(varName);
        methodArgs.push(`${mapping.cType} ${varName}`);
        usedHelpers.add("parseIntArray");
        return;
      }

      // 1D arrays
      if (item.startsWith("array-1")) {
        arrayInputProcLogic += `int ${varName}Size;\n${mapping.cType} ${varName} = ${mapping.parseFn}(argv[${actIndex}], &${varName}Size);\n`;
        passedArgs.push(varName, `${varName}Size`);
        methodArgs.push(`${mapping.cType} ${varName}`, `int ${varName}Size`);
        usedHelpers.add(mapping.parseFn);
        return;
      }

      // 2D arrays
      if (item.startsWith("array-2")) {
        arrayInputProcLogic += `int ${varName}Size; int* ${varName}ColSizes;\n${mapping.cType} ${varName} = ${mapping.parseFn}(argv[${actIndex}], &${varName}Size, &${varName}ColSizes);\n`;
        passedArgs.push(varName, `${varName}Size`, `${varName}ColSizes`);
        methodArgs.push(
          `${mapping.cType} ${varName}`,
          `int ${varName}Size`,
          `int* ${varName}ColSizes`,
        );
        usedHelpers.add(mapping.parseFn);
        return;
      }
    });

    // ---- 2. Return type: out-params for arrays, print logic ----
    const rv = returnType?.value;
    const rMapping = typeMap[rv];
    let returnOutParams = "";
    let returnOutParamDecls = "";
    let printLogic = "";

    if (rv === "int" || rv === "boolean") {
      printLogic = `printf("%d", output);`;
    } else if (rv === "float" || rv === "double") {
      printLogic = `printf("%.2f", output);`;
    } else if (rv === "string") {
      printLogic = `printf("%s", output);`;
    } else if (rv === "char") {
      printLogic = `printf("%c", output);`;
    } else if (rv?.startsWith("array-1")) {
      returnOutParams = ", int *returnSize";
      returnOutParamDecls = "int returnSize;\n      ";
      const fmt =
        rv === "array-1float"
          ? "%.2f"
          : rv === "array-1string"
          ? "%s"
          : rv === "array-1char"
          ? "%c"
          : "%d";
      printLogic = `
    printf("[");
    for (int i = 0; i < returnSize; i++) {
      printf("${fmt}", output[i]);
      if (i != returnSize - 1) printf(", ");
    }
    printf("]");`;
    } else if (rv?.startsWith("array-2")) {
      returnOutParams = ", int *returnSize, int **returnColumnSizes";
      returnOutParamDecls =
        "int returnSize;\n      int *returnColumnSizes;\n      ";
      const fmt =
        rv === "array-2float"
          ? "%.2f"
          : rv === "array-2string"
          ? "%s"
          : rv === "array-2char"
          ? "%c"
          : "%d";
      printLogic = `
    printf("[");
    for (int i = 0; i < returnSize; i++) {
      printf("[");
      for (int j = 0; j < returnColumnSizes[i]; j++) {
        printf("${fmt}", output[i][j]);
        if (j != returnColumnSizes[i] - 1) printf(", ");
      }
      printf("]");
      if (i != returnSize - 1) printf(", ");
    }
    printf("]");`;
    } else if (rv === "treenode") {
      printLogic = `printf("%s", serializeTree(output));`;
    } else if (rv === "listnode") {
      printLogic = `printf("%s", serializeList(output));`;
    }

    const changeRetype = rMapping ? rMapping.cType : "int";

    // ---- 3. Assemble call ----
    const callArgs = [...passedArgs];
    if (returnOutParams) {
      if (rv?.startsWith("array-2"))
        callArgs.push("&returnSize", "&returnColumnSizes");
      else callArgs.push("&returnSize");
    }

    // ---- 4. Node definitions: user-facing (struct only) vs runtime (struct+build+serialize) ----
    let nodeDefForUser = "";
    let nodeLogicRuntime = "";

    if (needTree) {
      const treeStruct = `typedef struct TreeNode {
    int val;
    struct TreeNode *left;
    struct TreeNode *right;
} TreeNode;
`;
      nodeDefForUser += `\n${treeStruct}`;
      nodeLogicRuntime += `\n${treeStruct}
TreeNode* buildTree(const char* s) {
    char* inner = stripOuterBrackets(s);
    int n; char** t = splitTopLevel(inner, &n);
    if (n == 0 || strcmp(t[0], "null") == 0) { freeTokens(t, n); free(inner); return NULL; }
    TreeNode** nodes = (TreeNode**)malloc(n * sizeof(TreeNode*));
    for (int i = 0; i < n; i++) {
        if (strcmp(t[i], "null") == 0) nodes[i] = NULL;
        else {
            nodes[i] = (TreeNode*)malloc(sizeof(TreeNode));
            nodes[i]->val = atoi(t[i]);
            nodes[i]->left = NULL;
            nodes[i]->right = NULL;
        }
    }
    int qHead = 0, i = 1;
    while (qHead < n && i < n) {
        TreeNode* node = nodes[qHead++];
        if (node == NULL) continue;
        if (i < n) node->left = nodes[i++];
        if (i < n) node->right = nodes[i++];
    }
    TreeNode* root = nodes[0];
    freeTokens(t, n); free(inner); free(nodes);
    return root;
}

char* serializeTree(TreeNode* root) {
    static char buf[10000];
    if (!root) { strcpy(buf, "[]"); return buf; }
    TreeNode* queue[10000];
    char* result[10000];
    int head = 0, tail = 0, size = 0;
    queue[tail++] = root;
    while (head < tail) {
      TreeNode* node = queue[head++];
      if (node == NULL) { result[size++] = "null"; }
      else {
        char* str = (char*)malloc(20);
        sprintf(str, "%d", node->val);
        result[size++] = str;
        queue[tail++] = node->left;
        queue[tail++] = node->right;
      }
    }
    // Remove trailing nulls
    while (size > 0 && strcmp(result[size - 1], "null") == 0) {
        size--;
    }
    strcpy(buf, "[");

    for (int i = 0; i < size; i++) {
        strcat(buf, result[i]);
        if (i != size - 1)
            strcat(buf, ",");
    }

    strcat(buf, "]");

    // Free allocated memory
    for (int i = 0; i < size; i++) {
        if (strcmp(result[i], "null") != 0)
            free(result[i]);
    }

    return buf;
}
`;
      usedHelpers.add("stripOuterBrackets");
      usedHelpers.add("splitTopLevel");
      usedHelpers.add("freeTokens");
    }

    if (needList) {
      const listStruct = `typedef struct ListNode {
    int val;
    struct ListNode *next;
} ListNode;
`;
      nodeDefForUser += `\n${listStruct}`;
      nodeLogicRuntime += `\n${listStruct}
ListNode* buildList(const char* s) {
    int size;
    int* vals = parseIntArray(s, &size);
    if (size == 0) { free(vals); return NULL; }
    ListNode* head = (ListNode*)malloc(sizeof(ListNode));
    head->val = vals[0]; head->next = NULL;
    ListNode* curr = head;
    for (int i = 1; i < size; i++) {
        curr->next = (ListNode*)malloc(sizeof(ListNode));
        curr->next->val = vals[i];
        curr->next->next = NULL;
        curr = curr->next;
    }
    free(vals);
    return head;
}

char* serializeList(ListNode* head) {
    static char buf[10000];
    strcpy(buf, "[");
    int first = 1;
    while (head) {
        char tmp[20];
        if (!first) strcat(buf, ", ");
        first = 0;
        sprintf(tmp, "%d", head->val);
        strcat(buf, tmp);
        head = head->next;
    }
    strcat(buf, "]");
    return buf;
}
`;
      usedHelpers.add("parseIntArray");
    }

    // ---- 5. Emit ONLY the requested helpers + their transitive dependencies ----
    const runtimeHelpers = resolveHelpers(Array.from(usedHelpers));

    // ---- 6. Assemble solution template (user-facing) and full runtime code ----
    const solutionTemplate = `/* Definition for node
${nodeDefForUser}
*/
${changeRetype} ${methodName}(${methodArgs.join(
      ", ",
    )}${returnOutParams}) { // Don't change the number of parameters
    // Please write your return statement here
}
`;
    const needsStdbool =
      changeRetype === "bool" ||
      methodArgs.some((a) => a.startsWith("bool")) ||
      changeRetype.includes("bool");
    const code = `#include <stdio.h>
#include <string.h>
#include <stdlib.h>
#include <ctype.h>
${needsStdbool ? "\n#include <stdbool.h>" : ""}

${runtimeHelpers}
${nodeLogicRuntime}

//Please don't modify the below code
$solution
int main(int argc, char *argv[]) {
      ${arrayInputProcLogic
        .split("\n")
        .map((l) => (l ? "  " + l : l))
        .join("\n")}
      ${returnOutParamDecls}${changeRetype} output = ${methodName}(${callArgs.join(
      ", ",
    )});
      ${printLogic}

      return 0;
}
`;

    return { boilerplate: code, solutionTemplate };
  } else {
    const code = `#include <stdio.h>
int main() {
  // Start to write code from here
  
  return 0;
}`;
    return { boilerplate: code, solutionTemplate: code };
  }
}

export function generateBoilerPlateCPPCode(
  methodName,
  argTypes,
  args,
  columns,
  returnType,
  isNoTestCases,
) {
  if (argTypes.includes("file")) {
    const typeMap = {
      int: "int",
      float: "double",
      Char: "char",
      String: "std::string",
      boolean: "bool",
      void: "void",
      file: "std::string",
    };

    const parseArg = (type, index) => {
      const arg = args[index];
      if (type === "int")
        return `${typeMap[type]} ${arg} = std::stoi(argv[${index + 1}]);`;
      if (type === "float" || type === "double")
        return `${typeMap[type]} ${arg} = std::stod(argv[${index + 1}]);`;
      if (type === "Char")
        return `${typeMap[type]} ${arg} = argv[${index + 1}][0];`;
      if (type === "boolean")
        return `${typeMap[type]} ${arg} = std::stoi(argv[${index + 1}]) != 0;`;
      return `${typeMap[type]} ${arg} = argv[${index + 1}];`; // string, file
    };

    const params = argTypes
      .map((type, i) => `${typeMap[type]} ${args[i]}`)
      .join(", ");

    let boilerplate = `#include <iostream>\n#include <fstream>\n#include <string>\nusing namespace std;\n\n`;

    boilerplate += `${
      typeMap[returnType.value]
    } ${methodName}(${params}) { // Don't change the number of parameters\n`;
    boilerplate += `    // Please write your code here\n`;
    // if (returnType.value !== "void") {
    //   boilerplate += `    return 0; // Replace with actual return\n`;
    // }
    boilerplate += `}\n\n`;

    // File Reader Helper
    if (
      (returnType.label === "New File" || returnType.label === "Same File") &&
      returnType.value === "void"
    ) {
      boilerplate += `void readFile(const string& filename) {\n`;
      boilerplate += `    ifstream file(filename);\n`;
      boilerplate += `    if (!file) {\n`;
      boilerplate += `        cout << "Error: Cannot open file " << filename;\n`;
      boilerplate += `        return;\n`;
      boilerplate += `    }\n`;
      boilerplate += `    string line;\n`;
      boilerplate += `    while (getline(file, line)) {\n`;
      boilerplate += `        cout << line;\n`;
      boilerplate += `    }\n`;
      boilerplate += `    file.close();\n`;
      boilerplate += `}\n\n`;
    }

    // Main
    boilerplate += `int main(int argc, char* argv[]) {\n`;
    // boilerplate += `    if (argc < ${argTypes.length + 1}) {\n`;
    // boilerplate += `        cout << "Insufficient arguments" << endl;\n`;
    // boilerplate += `        return 1;\n`;
    // boilerplate += `    }\n\n`;

    argTypes.forEach((type, i) => {
      boilerplate += `    ${parseArg(type, i)}\n`;
    });

    const callExpr = `${methodName}(${args.join(", ")})`;
    const value = returnType.label === "New File" ? argTypes.length : 1;

    if (returnType.value === "void") {
      boilerplate += `    ${callExpr};\n`;
      if (returnType.label === "new File" || returnType.label === "Same File") {
        boilerplate += `    readFile(argv[${value}]);\n`;
      }
    } else {
      boilerplate += `    auto result = ${callExpr};\n`;
      boilerplate += `    cout << result;\n`;
    }

    boilerplate += `    return 0;\n}`;
    return boilerplate;
  } else if (!isNoTestCases) {
    const typeMap = {
      int: { cType: "int", parseExpr: (v) => `atoi(${v})` },
      float: { cType: "float", parseExpr: (v) => `stof(${v})` },
      double: { cType: "double", parseExpr: (v) => `stod(${v})` },
      string: { cType: "string", parseExpr: (v) => `string(${v})` },
      char: { cType: "char", parseExpr: (v) => `${v}[0]` },
      boolean: { cType: "bool", parseExpr: (v) => `(string(${v}) == "true")` },

      "array-1int": { cType: "vector<int>", parseFn: "parseVectorInt" },
      "array-1float": { cType: "vector<float>", parseFn: "parseVectorFloat" },
      "array-1char": { cType: "vector<char>", parseFn: "parseVectorChar" },
      "array-1boolean": { cType: "vector<bool>", parseFn: "parseVectorBool" },
      "array-1string": {
        cType: "vector<string>",
        parseFn: "parseVectorString",
      },

      "array-2int": { cType: "vector<vector<int>>", parseFn: "parseMatrixInt" },
      "array-2float": {
        cType: "vector<vector<float>>",
        parseFn: "parseMatrixFloat",
      },
      "array-2char": {
        cType: "vector<vector<char>>",
        parseFn: "parseMatrixChar",
      },
      "array-2boolean": {
        cType: "vector<vector<bool>>",
        parseFn: "parseMatrixBool",
      },
      "array-2string": {
        cType: "vector<vector<string>>",
        parseFn: "parseMatrixString",
      },

      treenode: { cType: "TreeNode*", parseFn: "buildTree" },
      listnode: { cType: "ListNode*", parseFn: "buildList" },
    };

    // ---- Individually named helper snippets + their dependencies (same pattern as the C version) ----
    const HELPER_LIB = {
      stripOuterBrackets: {
        deps: [],
        code: `static string stripOuterBrackets(const string& s) {
    int start = 0, end = (int)s.size() - 1;
    while (start < (int)s.size() && (s[start] == '[' || s[start] == ' ')) start++;
    while (end >= start && (s[end] == ']' || s[end] == ' ')) end--;
    if (end < start) return "";
    return s.substr(start, end - start + 1);
}`,
      },
      stripQuotes: {
        deps: [],
        code: `static string stripQuotes(const string& s) {
    string r;
    for (char c : s) if (c != '"' && c != ' ') r += c;
    return r;
}`,
      },
      splitTopLevel: {
        deps: [],
        code: `static vector<string> splitTopLevel(const string& s) {
    vector<string> parts;
    if (s.empty()) return parts;
    int depth = 0, start = 0;
    for (int i = 0; i < (int)s.size(); i++) {
        if (s[i] == '[') depth++;
        else if (s[i] == ']') depth--;
        else if (s[i] == ',' && depth == 0) {
            parts.push_back(s.substr(start, i - start));
            start = i + 1;
        }
    }
    parts.push_back(s.substr(start));
    return parts;
}`,
      },
      parseVectorInt: {
        deps: ["stripOuterBrackets", "splitTopLevel"],
        code: `vector<int> parseVectorInt(const string& s) {
    vector<int> result;
    for (auto& tok : splitTopLevel(stripOuterBrackets(s))) result.push_back(stoi(tok));
    return result;
}`,
      },
      parseVectorFloat: {
        deps: ["stripOuterBrackets", "splitTopLevel"],
        code: `vector<float> parseVectorFloat(const string& s) {
    vector<float> result;
    for (auto& tok : splitTopLevel(stripOuterBrackets(s))) result.push_back(stof(tok));
    return result;
}`,
      },
      parseVectorChar: {
        deps: ["stripOuterBrackets", "splitTopLevel", "stripQuotes"],
        code: `vector<char> parseVectorChar(const string& s) {
    vector<char> result;
    for (auto& tok : splitTopLevel(stripOuterBrackets(s))) result.push_back(stripQuotes(tok)[0]);
    return result;
}`,
      },
      parseVectorBool: {
        deps: ["stripOuterBrackets", "splitTopLevel"],
        code: `vector<bool> parseVectorBool(const string& s) {
    vector<bool> result;
    for (auto& tok : splitTopLevel(stripOuterBrackets(s))) result.push_back(tok.find("true") != string::npos);
    return result;
}`,
      },
      parseVectorString: {
        deps: ["stripOuterBrackets", "splitTopLevel", "stripQuotes"],
        code: `vector<string> parseVectorString(const string& s) {
    vector<string> result;
    for (auto& tok : splitTopLevel(stripOuterBrackets(s))) result.push_back(stripQuotes(tok));
    return result;
}`,
      },
      parseMatrixInt: {
        deps: ["stripOuterBrackets", "splitTopLevel", "parseVectorInt"],
        code: `vector<vector<int>> parseMatrixInt(const string& s) {
    vector<vector<int>> result;
    for (auto& row : splitTopLevel(stripOuterBrackets(s))) result.push_back(parseVectorInt(row));
    return result;
}`,
      },
      parseMatrixFloat: {
        deps: ["stripOuterBrackets", "splitTopLevel", "parseVectorFloat"],
        code: `vector<vector<float>> parseMatrixFloat(const string& s) {
    vector<vector<float>> result;
    for (auto& row : splitTopLevel(stripOuterBrackets(s))) result.push_back(parseVectorFloat(row));
    return result;
}`,
      },
      parseMatrixChar: {
        deps: ["stripOuterBrackets", "splitTopLevel", "parseVectorChar"],
        code: `vector<vector<char>> parseMatrixChar(const string& s) {
    vector<vector<char>> result;
    for (auto& row : splitTopLevel(stripOuterBrackets(s))) result.push_back(parseVectorChar(row));
    return result;
}`,
      },
      parseMatrixBool: {
        deps: ["stripOuterBrackets", "splitTopLevel", "parseVectorBool"],
        code: `vector<vector<bool>> parseMatrixBool(const string& s) {
    vector<vector<bool>> result;
    for (auto& row : splitTopLevel(stripOuterBrackets(s))) result.push_back(parseVectorBool(row));
    return result;
}`,
      },
      parseMatrixString: {
        deps: ["stripOuterBrackets", "splitTopLevel", "parseVectorString"],
        code: `vector<vector<string>> parseMatrixString(const string& s) {
    vector<vector<string>> result;
    for (auto& row : splitTopLevel(stripOuterBrackets(s))) result.push_back(parseVectorString(row));
    return result;
}`,
      },
    };

    function resolveHelpers(requested) {
      const included = new Set();
      const order = [];
      function visit(name) {
        if (included.has(name)) return;
        included.add(name);
        const entry = HELPER_LIB[name];
        if (!entry) return;
        entry.deps.forEach(visit);
        order.push(name);
      }
      requested.forEach(visit);
      return order.map((n) => HELPER_LIB[n].code).join("\n\n");
    }

    const usedHelpers = new Set();
    const passedArgs = [];
    const methodArgs = [];
    let inputProcLogic = "";

    const needTree =
      argTypes.includes("treenode") || returnType?.value === "treenode";
    const needList =
      argTypes.includes("listnode") || returnType?.value === "listnode";

    // ---- 1. Input processing + call args + method signature params ----
    argTypes.forEach((item, index) => {
      const varName = args[index];
      const actIndex = index + 1; // argv[0] is program name
      const mapping = typeMap[item];

      if (
        ["int", "float", "double", "string", "char", "boolean"].includes(item)
      ) {
        passedArgs.push(mapping.parseExpr(`argv[${actIndex}]`));
        methodArgs.push(`${mapping.cType} ${varName}`);
        return;
      }

      if (item === "treenode") {
        inputProcLogic += `TreeNode* ${varName} = buildTree(argv[${actIndex}]);\n`;
        passedArgs.push(varName);
        methodArgs.push(`${mapping.cType} ${varName}`);
        usedHelpers.add("stripOuterBrackets");
        usedHelpers.add("splitTopLevel");
        return;
      }

      if (item === "listnode") {
        inputProcLogic += `ListNode* ${varName} = buildList(argv[${actIndex}]);\n`;
        passedArgs.push(varName);
        methodArgs.push(`${mapping.cType} ${varName}`);
        usedHelpers.add("parseVectorInt");
        return;
      }

      // all array types (1D and 2D) — vectors carry their own size, no out-params needed
      inputProcLogic += `${mapping.cType} ${varName} = ${mapping.parseFn}(argv[${actIndex}]);\n`;
      passedArgs.push(varName);
      methodArgs.push(`${mapping.cType} ${varName}`);
      usedHelpers.add(mapping.parseFn);
    });

    // ---- 2. Return type + print logic ----
    const rv = returnType?.value;
    const rMapping = typeMap[rv];
    const returnCppType = rMapping ? rMapping.cType : rv; // int/float/double/char fall through as-is

    let printLogic = "";
    if (rv === "int" || rv === "double" || rv === "char") {
      printLogic = `cout << output;`;
    } else if (rv === "float") {
      printLogic = `cout << fixed << setprecision(2) << output;`;
    } else if (rv === "boolean") {
      printLogic = `cout << (output ? "true" : "false");`;
    } else if (rv === "string") {
      printLogic = `cout << output;`;
    } else if (rv === "array-1int" || rv === "array-1boolean") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) { if (i) cout << ", "; cout << output[i]; }
    cout << "]";`;
    } else if (rv === "array-1float") {
      printLogic = `
    cout << fixed << setprecision(2);
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) { if (i) cout << ", "; cout << output[i]; }
    cout << "]";`;
    } else if (rv === "array-1char") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) { if (i) cout << ", "; cout << "'" << output[i] << "'"; }
    cout << "]";`;
    } else if (rv === "array-1string") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) { if (i) cout << ", "; cout << "\\"" << output[i] << "\\""; }
    cout << "]";`;
    } else if (rv === "array-2int" || rv === "array-2boolean") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) {
      if (i) cout << ", ";
      cout << "[";
      for (size_t j = 0; j < output[i].size(); j++) { if (j) cout << ", "; cout << output[i][j]; }
      cout << "]";
    }
    cout << "]";`;
    } else if (rv === "array-2float") {
      printLogic = `
    cout << fixed << setprecision(2);
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) {
      if (i) cout << ", ";
      cout << "[";
      for (size_t j = 0; j < output[i].size(); j++) { if (j) cout << ", "; cout << output[i][j]; }
      cout << "]";
    }
    cout << "]";`;
    } else if (rv === "array-2char") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) {
      if (i) cout << ", ";
      cout << "[";
      for (size_t j = 0; j < output[i].size(); j++) { if (j) cout << ", "; cout << "'" << output[i][j] << "'"; }
      cout << "]";
    }
    cout << "]";`;
    } else if (rv === "array-2string") {
      printLogic = `
    cout << "[";
    for (size_t i = 0; i < output.size(); i++) {
      if (i) cout << ", ";
      cout << "[";
      for (size_t j = 0; j < output[i].size(); j++) { if (j) cout << ", "; cout << "\\"" << output[i][j] << "\\""; }
      cout << "]";
    }
    cout << "]";`;
    } else if (rv === "treenode") {
      printLogic = `cout << serializeTree(output);`;
      usedHelpers.add("stripOuterBrackets");
      usedHelpers.add("splitTopLevel");
    } else if (rv === "listnode") {
      printLogic = `cout << serializeList(output);`;
    }

    // ---- 3. Node struct + build/serialize (TreeNode/ListNode) ----
    let nodeDefForUser = "";
    let nodeLogicRuntime = "";

    if (needTree) {
      const treeStruct = `struct TreeNode {
    int val;
    TreeNode *left;
    TreeNode *right;
    TreeNode() : val(0), left(nullptr), right(nullptr) {}
    TreeNode(int x) : val(x), left(nullptr), right(nullptr) {}
    TreeNode(int x, TreeNode *left, TreeNode *right) : val(x), left(left), right(right) {}
};
`;
      nodeDefForUser += `\n${treeStruct}`;
      nodeLogicRuntime += `\n${treeStruct}
TreeNode* buildTree(const string& s) {
    auto tokens = splitTopLevel(stripOuterBrackets(s));
    if (tokens.empty() || tokens[0] == "null") return nullptr;
    vector<TreeNode*> nodes;
    for (auto& t : tokens) nodes.push_back(t == "null" ? nullptr : new TreeNode(stoi(t)));
    int i = 1;
    for (size_t qi = 0; qi < nodes.size() && i < (int)nodes.size(); qi++) {
        if (!nodes[qi]) continue;
        if (i < (int)nodes.size()) nodes[qi]->left = nodes[i++];
        if (i < (int)nodes.size()) nodes[qi]->right = nodes[i++];
    }
    return nodes[0];
}

string serializeTree(TreeNode* root) {
    if (!root) return "[]";
    vector<string> parts;
    queue<TreeNode*> q; q.push(root);
    while (!q.empty()) {
        TreeNode* node = q.front(); q.pop();
        if (!node) { parts.push_back("null"); continue; }
        parts.push_back(to_string(node->val));
        q.push(node->left); q.push(node->right);
    }
    while (!parts.empty() && parts.back() == "null") parts.pop_back();
    string result = "[";
    for (size_t i = 0; i < parts.size(); i++) { if (i) result += ", "; result += parts[i]; }
    return result + "]";
}
`;
    }

    if (needList) {
      const listStruct = `struct ListNode {
    int val;
    ListNode *next;
    ListNode() : val(0), next(nullptr) {}
    ListNode(int x) : val(x), next(nullptr) {}
    ListNode(int x, ListNode *next) : val(x), next(next) {}
};
`;
      nodeDefForUser += `\n${listStruct}`;
      nodeLogicRuntime += `\n${listStruct}
ListNode* buildList(const string& s) {
    auto vals = parseVectorInt(s);
    if (vals.empty()) return nullptr;
    ListNode* head = new ListNode(vals[0]);
    ListNode* curr = head;
    for (size_t i = 1; i < vals.size(); i++) { curr->next = new ListNode(vals[i]); curr = curr->next; }
    return head;
}

string serializeList(ListNode* head) {
    string result = "[";
    bool first = true;
    while (head) { if (!first) result += ", "; first = false; result += to_string(head->val); head = head->next; }
    return result + "]";
}
`;
    }

    // ---- 4. Only emit the runtime helpers actually needed ----
    const runtimeHelpers = resolveHelpers(Array.from(usedHelpers));

    // ---- 5. Solution template (user-facing): struct only, no build/serialize/parse internals ----
    const solutionTemplate = `/* Definition for node
${nodeDefForUser}
*/
class Solution {
public:
    ${returnCppType} ${methodName}(${methodArgs.join(
      ", ",
    )}) { // Don't change the number of parameters
        // Please write your return statement here
    }
};
`;

    // ---- 6. Full runtime code ----
    const code = `#include <iostream>
#include <vector>
#include <string>
#include <queue>
#include <iomanip>
using namespace std;

${runtimeHelpers}
${nodeLogicRuntime}

//Please don't modify the below code
$solution
int main(int argc, char *argv[]) {
    ${inputProcLogic
      .split("\n")
      .map((l) => (l ? "  " + l : l))
      .join("\n")}
    Solution sol;
    ${returnCppType} output = sol.${methodName}(${passedArgs.join(", ")});
    ${printLogic}

    return 0;
}
`;

    return { boilerplate: code, solutionTemplate };
  } else {
    const code = `#include <iostream>

using namespace std;

int main() {
  //Start to write code here

  return 0;
}`;

    return code;
  }
}

export const changeFavicon = (favicon) => {
  if (favicon && favicon !== "") {
    let link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = favicon;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
};

export const emailBody = `<table style="border-collapse: collapse;border:0">
<tr>
    <td>
        <table style="border-collapse: collapse;">
            <tr>
                <td
                    style="font-weight: 400; font-size: 14px; line-height: 24px;">
                    Welcome to the Gradious Learning Platform (LEAP)! We are
                    thrilled to
                    have you on board and excited to help you embark on your
                    learning
                    journey with us.
                </td>
            </tr>
            <tr>
                <td
                    style="font-weight: 400; font-size: 14px; line-height: 24px; padding: 8px 0 0;">
                    Our Learning Management System (LMS) is designed to provide
                    you with an
                    exceptional educational experience, offering a wide range of
                    resources,
                    interactive tools, and support to help you achieve your
                    learning goals.
                </td>
            </tr>
        </table>
    </td>
</tr>
<tr>
    <td style="padding: 16px 0 0;">
        <table style="border-collapse: collapse;">
            <tr>
                <td
                    style="font-weight: 400; font-size: 14px; line-height: 24px;">
                    You can get started by:
                </td>
            </tr>
            <tr>
                <td>
                    <ol style="margin: 0; padding-top: 8px;">
                        <li
                            style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
                            Visit our LMS platform at
                            <span>
                                <a href="https://leap.gradious.com"
                                    data-saferedirecturl="https:leap.gradious.com"
                                    target="_blank" rel="noopener noreferrer"
                                    style="color: #175CD3; text-decoration: none;">
                                    [leap.gradious.com]
                                </a>.
                            </span>
                        </li>
                        <li
                            style="font-weight: 400; font-size: 14px; line-height: 24px;">
                            Login using “Sign-in with Google” with the same
                            Google account
                            you received this mail in.
                        </li>
                    </ol>
                </td>
            </tr>
        </table>
    </td>
</tr>
<tr>
    <td
        style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
        Thank you for choosing Gradious Technologies as your learning partner.
        Let’s begin
        this exciting journey together!
    </td>
</tr>
</table>`;

export const adminEmailBody = `<table style="border-collapse: collapse; border: 0;">
<tr>
  <td>
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 400; font-size: 14px; line-height: 24px;">
          Welcome to the Gradious Learning Platform (LEAP)! We are delighted to have you join our <strong>admin team</strong>.
        </td>
      </tr>
      <tr>
        <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 8px;">
          As an administrator, you play a crucial role in shaping the learning experiences of our students and supporting our educators. Our Learning Management System (LMS) offers you a comprehensive suite of tools to manage courses, users, and content efficiently.
        </td>
      </tr>
    </table>
  </td>
</tr>
<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          Getting Started:
        </td>
      </tr>
      <tr>
        <td>
          <ol style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Access the admin portal at
              <a href="https://leap.gradious.com" target="_blank" rel="noopener noreferrer" style="color: #175CD3; text-decoration: none;">
                leap.gradious.com
              </a>.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              Log in using “Sign-in with Google” with the same Google account this email was sent to.
            </li>
          </ol>
        </td>
      </tr>
    </table>
  </td>
</tr>
<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    If you need any assistance or have questions about your new admin tools and features, our support team is here to help. We look forward to working together to create outstanding learning experiences!
  </td>
</tr>
<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Best regards,<br/>
    The Gradious Team
  </td>
</tr>
</table>`;

export const internalTrainerEmailBody = `<table style="border-collapse: collapse; border: 0;">
<tr>
  <td>
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 400; font-size: 14px; line-height: 24px;">
          We are excited to welcome you as an <strong>internal trainer</strong> to the Gradious Learning Platform (LEAP)! Your expertise and guidance will be invaluable as you support our learners and contribute to their success stories.
        </td>
      </tr>
    </table>
  </td>
</tr>
<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          Getting Started Steps:
        </td>
      </tr>
      <tr>
        <td>
          <ol style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Visit our platform:
              <a href="https://leap.gradious.com" target="_blank" rel="noopener noreferrer" style="color: #175CD3; text-decoration: none;">
                leap.gradious.com
              </a>
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Log in using “Sign-in with Google” and the same Google account this email was sent to.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              Once logged in, you’ll see the dashboard tailored with trainer tools and options.
            </li>
          </ol>
        </td>
      </tr>
    </table>
  </td>
</tr>
<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Thank you for joining Gradious Technologies as a valued member of our trainer team. We’re looking forward to the expertise and enthusiasm you’ll bring to our team.
  </td>
</tr>
<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Let’s work together to provide an exceptional learning experience for our students!
  </td>
</tr>
<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Best regards,<br/>
    The Gradious Team
  </td>
</tr>
</table>`;

export const tpoEmailBody = `<table style="border-collapse: collapse; border: 0;">
<tr>
  <td>
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 400; font-size: 14px; line-height: 24px;">
          We are pleased to welcome you as a <strong>Training and Placement Officer (TPO)</strong> on the Gradious Learning Platform (LEAP).
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          Getting Started Steps:
        </td>
      </tr>
      <tr>
        <td>
          <ol style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Visit our platform:
              <a href="https://leap.gradious.com" target="_blank" rel="noopener noreferrer" style="color: #175CD3; text-decoration: none;">
                leap.gradious.com
              </a>
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Log in using “Sign-in with Google” and the same Google account this email was sent to.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              Once logged in, you will have access to a dashboard specifically designed for TPOs, where you can view and track performance metrics and progress of students from your college.
            </li>
          </ol>
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          With this access, you can:
        </td>
      </tr>
      <tr>
        <td>
          <ul style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              <strong>Monitor student progress:</strong> Get insights into course engagement, assessment performance, and overall learning outcomes for your institution’s students.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              <strong>Support your learners:</strong> Identify strengths and areas for improvement to better assist your students throughout their courses.
            </li>
          </ul>
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Thank you for partnering with Gradious Technologies. We look forward to working closely with you to enable greater student success in your college.
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Let’s collaborate to provide an exceptional learning experience for every student!
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Best regards,<br/>
    The Gradious Team
  </td>
</tr>
</table>`;

export const parentEmailBody = `<table style="border-collapse: collapse; border: 0;">
<tr>
  <td>
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 400; font-size: 14px; line-height: 24px;">
          We are pleased to welcome you as a <strong>Parent</strong> user on the Gradious Learning Platform (LEAP).
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          With your parent login, you can:
        </td>
      </tr>
      <tr>
        <td>
          <ul style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              <strong>Monitor your child’s progress:</strong> View learning milestones, course completions, and performance details to stay informed about your child’s educational achievements.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              <strong>Track attendance:</strong> Review daily attendance and participation, helping you ensure your child is consistent in their learning.
            </li>
          </ul>
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="padding-top: 16px;">
    <table style="border-collapse: collapse;">
      <tr>
        <td style="font-weight: 600; font-size: 14px; line-height: 24px;">
          Getting Started Steps:
        </td>
      </tr>
      <tr>
        <td>
          <ol style="margin: 0; padding-top: 8px; padding-left: 20px;">
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Visit our platform:
              <a href="https://leap.gradious.com" target="_blank" rel="noopener noreferrer" style="color: #175CD3; text-decoration: none;">
                leap.gradious.com
              </a>
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px; padding-bottom: 8px;">
              Log in using “Sign-in with Google” and the same Google account this email was sent to.
            </li>
            <li style="font-weight: 400; font-size: 14px; line-height: 24px;">
              Once logged in, your dashboard will provide tailored insights and attendance records for your child.
            </li>
          </ol>
        </td>
      </tr>
    </table>
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    If you have any questions or need assistance navigating the platform, feel free to contact our support team at any time.
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Thank you for choosing Gradious Technologies. With your continued support, together we can help your child realize their fullest potential.
  </td>
</tr>

<tr>
  <td style="font-weight: 400; font-size: 14px; line-height: 24px; padding-top: 16px;">
    Best regards,<br/>
    The Gradious Team
  </td>
</tr>
</table>`;

export const MANAGEMENTROLES = [
  constants.Roles.admin,
  constants.Roles.trainer,
  constants.Roles.hr,
  constants.Roles.super_admin,
];

export const USERSROLES = [constants.Roles.learner, constants.Roles.parent];

export function isClosingSoon(registrationEndDateStr) {
  const today = new Date();
  const endDate = new Date(registrationEndDateStr);

  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const diffInMs = endDate - today;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  // console.log("diffInDays >= 0 && diffInDays <= 2", diffInDays >= 0 && diffInDays <= 2);

  return diffInDays >= 0 && diffInDays <= 2;
}

export const isParentLogin =
  getDataFromStorage("role") === constants.Roles.parent;

export const getContentType = (content) => {
  if (!content) return "unknown";

  // Case: EditorJS JSON (string)
  if (typeof content === "string") {
    try {
      const parsed = JSON.parse(content);

      if (
        parsed &&
        typeof parsed === "object" &&
        Array.isArray(parsed.blocks) &&
        parsed.version
      ) {
        return "editor";
      }
    } catch (e) {
      // not JSON → ignore
    }

    // HTML string
    if (/<[a-z][\s\S]*>/i.test(content)) {
      return "html";
    }
  }

  return "unknown";
};

export const sanitizeName = (value) => {
  const name = String(value || "").trim();

  return ["null", "undefined", ""].includes(name.toLowerCase()) ? "" : name;
};
